module.exports = __webpack_public_path__ + "static/media/christmasLights.26c25345.png";